<template>
    <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.68018 1L1.67929 8.00089L8.68018 15.0018" stroke="#5F5F63" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {
    name: "IconChevronLeft"
}
</script>

<style scoped>

</style>
